import React, { useState, useEffect } from 'react';
import { Button, TextArea, Flex, Box } from '@scale/scaleui-radix';
import { useLookupUserIdsOrEmails } from 'react-scale/components/WebinarSessions/api';
import { uniq } from 'lodash';

interface UserIdOrEmailInputProps {
  userIds: string[];
  setUsersIds: (ids: string[]) => void;
}

export const UserIdOrEmailInput: React.FC<UserIdOrEmailInputProps> = ({ userIds, setUsersIds }) => {
  const [rawUserIdsOrEmailsText, setRawUserIdsOrEmailsText] = useState<string>('');
  const [shouldAdd, setShouldAdd] = useState<boolean>(false);

  const {
    data: userData,
    refetch,
    isFetching,
  } = useLookupUserIdsOrEmails({
    userIdsOrEmails: rawUserIdsOrEmailsText.split(/[ :;?!~,`"&|()<>{}[\]\r\n/\\]+/),
    enabled: false,
  });

  useEffect(() => {
    const updatedUserIds = uniq([...userIds, ...(userData ?? []).map(user => user.id)]);
    if (updatedUserIds.length > userIds.length && shouldAdd) {
      setUsersIds(updatedUserIds);
      setRawUserIdsOrEmailsText('');
      setShouldAdd(false);
    }
  }, [userData, userIds, setUsersIds, shouldAdd]);

  return (
    <Flex direction="column" gap="2" align="center">
      <Box width="100%">
        <TextArea
          size="2"
          placeholder="User IDs or emails, delimited"
          value={rawUserIdsOrEmailsText}
          onChange={e => setRawUserIdsOrEmailsText(e.target.value)}
          disabled={isFetching}
        />
      </Box>
      <Flex justify="end" width="100%">
        <Button
          variant="outline"
          loading={isFetching}
          onClick={() => {
            setShouldAdd(true);
            refetch();
          }}
        >
          Add
        </Button>
      </Flex>
    </Flex>
  );
};
